type ObjectMapFunction<T, U> = (value: T) => U;

export function mapObj<T, U, K extends string>(
  obj: Record<K, T>,
  fn: ObjectMapFunction<T, U>,
): Record<K, U> {
  const result = {} as Record<K, U>;

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      result[key] = fn(obj[key]);
    }
  }

  return result;
}
